/** Org-scoped API media paths for Neo adaptors (D14: pass creative org explicitly). */

export function orgApiPathForOrg(orgId: number | string, suffix: string): string {
  const path = suffix.startsWith('/') ? suffix : `/${suffix}`;
  return `/organizations/${orgId}${path}`;
}

/** Same-origin URL for cookie-authenticated ``<video src>`` / library items. */
export function orgMediaUrlForOrg(orgId: number | string, suffix: string): string {
  return `/api/v1${orgApiPathForOrg(orgId, suffix)}`;
}

export function assetContentUrl(orgId: number | string, assetId: number): string {
  return orgMediaUrlForOrg(orgId, `/assets/${assetId}/content`);
}

export function assetThumbnailUrl(orgId: number | string, assetId: number): string {
  return orgMediaUrlForOrg(orgId, `/assets/${assetId}/thumbnail`);
}

/** Prefer persisted thumb; fall back to content while video thumbs are still generating. */
export function resolveAssetThumbnailUrl(
  orgId: number | string,
  asset: { id: number | null; thumbnail_url?: string | null },
): string {
  if (asset.id == null) {
    throw new Error('Asset id is required for media URLs');
  }
  if (asset.thumbnail_url) {
    return assetThumbnailUrl(orgId, asset.id);
  }
  return assetContentUrl(orgId, asset.id);
}
